<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import * as track from './service/tracking';
export default {
  name: 'App',
  mounted() {
    // track.init();
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
